import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Spinner,
} from '@heroui/react';
import { FC, ReactNode } from 'react';

import { Flex } from '../Flex';
import { TranslationStatus, TranslationStatusData } from '../TranslationStatus';

interface ModalFormProps {
    isOpen: boolean;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
    onClose?: () => void;
    children?: ReactNode;
    title: string;
    description?:string;
    form?: string;
    isLoading?: boolean;
    scrollBehavior?: 'inside' | 'outside' | 'normal';
    translationStatus?: TranslationStatusData;
}
export const ModalForm: FC<ModalFormProps> = ({
  isOpen, size, onClose, children, title, form,
  isLoading, scrollBehavior, description, translationStatus,
}) => (
  <Modal
    isOpen={isOpen}
    size={size}
    onClose={onClose}
    radius="sm"
    backdrop="blur"
    scrollBehavior={scrollBehavior || 'normal'}
    isDismissable={false}
  >
    <ModalContent>
      {/* eslint-disable-next-line @typescript-eslint/no-shadow */}
      {(onClose) => (
        <>
          <ModalHeader className="flex flex-col gap-1 text-[20px] font-[500]">
            <Flex direction="row" gap="20px" itemAlign="center">
              {title || 'Modal'}
              <TranslationStatus status={translationStatus} />
            </Flex>
          </ModalHeader>
          <ModalBody>
            {description && <p className="text-md text-gray-500">{description}</p>}
            {children}
          </ModalBody>
          <ModalFooter>
            <Flex direction="row" justifyContent="flex-end" gap="10px">
              <Button color="default" variant="light" onPress={onClose} radius="full" size="md" isDisabled={isLoading}>
                Anuluj
              </Button>
              <Button
                color="secondary"
                radius="full"
                size="md"
                type={form ? 'submit' : 'button'}
                variant="solid"
                form={form}
                disabled={isLoading}
                onPress={form ? undefined : onClose}
                startContent={isLoading && <Spinner size="sm" color="white" />}
              >
                Zapisz
              </Button>
            </Flex>
          </ModalFooter>
        </>
      )}
    </ModalContent>
  </Modal>
);
